import type { IconData } from '@stacksjs/iconify-core'

export const horizontalMenuCircleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 4.5C13.23 4.5 4.5 13.23 4.5 24S13.23 43.5 24 43.5S43.5 34.77 43.5 24S34.77 4.5 24 4.5M.5 24C.5 11.021 11.021.5 24 .5S47.5 11.021 47.5 24S36.979 47.5 24 47.5S.5 36.979.5 24M24 19a5 5 0 1 0 0 10a5 5 0 0 0 0-10M7.5 24a5 5 0 1 1 10 0a5 5 0 0 1-10 0m28-5a5 5 0 1 0 0 10a5 5 0 0 0 0-10\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default horizontalMenuCircleRemix
